import React from 'react'

const createMarkup = (data) => {
  if (data) {
    return { __html: data };
  } else {
    return { __html: <p></p> };
  }
}

const AdminCareerDetails = ({ data, updateRoutePage }) => {

  return (
    <section className="dash-alert-details">
      <nav className="mb-4">
        <ol className="breadcrumb alert-breadcrumb">
        <li className="breadcrumb-item"><a style={{ color: 'rgb(30, 144, 255)' }} onClick={() => updateRoutePage('careers')}>Careers</a></li>
          <li className="breadcrumb-item active" aria-current="page">{data.title}</li>
        </ol>
      </nav>

      <div className="row">
        <div className="col-lg-3 mb-3">
          <div className="nav flex-column nav-pills alert-tab" id="v-pills-tab" role="tablist" aria-orientation="vertical">
            <a className="nav-link active" id="v-pills-home-tab" data-toggle="pill" href="#info" role="tab">About</a>
            <a className="nav-link" id="v-pills-profile-tab" data-toggle="pill" href="#process" role="tab">Typical Opportunities</a>
            <a className="nav-link" id="v-pills-profile-tab" data-toggle="pill" href="#eligible" role="tab">Qualities</a>
          </div>
        </div>
        <div className="col-lg-9 pl-lg-0">
          <div className="tab-content alert-tab-content" id="v-pills-tabContent">
            <div className="tab-pane fade show active" id="info">
              {data.domain ? <div dangerouslySetInnerHTML={createMarkup(data.domain)}></div> : ""}
            </div>
            <div className="tab-pane fade" id="process">
              {data.opportunities ? <div dangerouslySetInnerHTML={createMarkup(data.opportunities)}></div> : ""}
            </div>
            <div className="tab-pane fade" id="eligible">
              {data.skills ? <div dangerouslySetInnerHTML={createMarkup(data.skills)}></div> : ""}
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default AdminCareerDetails


/** WEBPACK FOOTER **
 ** ./src/components/Admin/AdminCareers/AdminCareerDetails/index.js
 **/